<template>
  <div class="custom-v-dialog">
    <v-dialog v-model="dialog" width="50vw" persistent>
      <template>
        <div class="custom-empty-modal-wrapper">
          <div class="m-header">
            <div class="title-header">
              <span>{{ $t('components.email.response.title') }}</span>
            </div>
          </div>
          <div class="m-center-part">
            <email-autocomplete-multi
              v-if="loaded_ck"
              :is_main="true"
              :textSuggest="$t('components.email.response.recipients')"
              :previous_filled_emails="formData.recipients"
              @ccVisible="(val) => (cc_visible = val)"
              @bccVisible="(val) => (bcc_visible = val)"
              @emailArrayChange="(val) => (formData.recipients = val)"
            />
            <email-autocomplete-multi
              v-if="cc_visible"
              textSuggest="CC"
              :is_main="false"
              :previous_filled_emails="formData.cc"
              @emailArrayChange="(val) => (formData.cc = val)"
            />

            <email-autocomplete-multi
              v-if="bcc_visible"
              textSuggest="BCC"
              :is_main="false"
              :previous_filled_emails="formData.bcc"
              @emailArrayChange="(val) => (formData.bcc = val)"
            />

            <div class="email-subject-wrapper">
              <div class="subject-label">
                <span class="label-text">{{ $t('components.email.response.subject') }}</span>
              </div>
              <v-text-field
                class="email-subject-input"
                v-model="formData.subject"
                hide-details
                single-line
                required
              ></v-text-field>
            </div>

            <div class="email-body-wrapper">
              <div class="body-label">{{ $t('components.email.response.email') }}</div>
              <ckeditor
                v-if="loaded_ck"
                :editor="editor"
                v-model="formData.body"
                :config="editorConfig"
              ></ckeditor>
            </div>

            <div class="attachment-line">
              <email-attachments-email-compose
                :attachments="finalFileList"
                @deleteAttach="deleteAttachmentFromArr"
                @openEditFiles="openLocalFileUpload()"
                :key="finalFileList.length"
              />
            </div>

            <div class="email-response-activities">
              <div
                class="attachment-button m-btn-wrapp"
                @click="openLocalFileUpload()"
              >
                <div class="m-single-btn m-single-prilog">
                  <svg
                    id="Layer_2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32.78 30.51"
                  >
                    <defs></defs>
                    <g id="Layer_1-2">
                      <path
                        class="cls-1"
                        d="M15.49,30.51c-.32,0-.64-.12-.88-.37-.49-.49-.49-1.28,0-1.77l13.57-13.57c1.36-1.36,2.1-3.16,2.1-5.08s-.75-3.72-2.1-5.08-3.23-2.15-5.19-2.15-3.8.76-5.19,2.15L3.97,18.48c-.95.95-1.47,2.21-1.47,3.55s.52,2.6,1.47,3.55l.3.3c1.78,1.78,4.67,1.78,6.45,0l12.67-12.67c.52-.52.81-1.22.81-1.96s-.29-1.43-.81-1.96c-1.04-1.04-2.87-1.05-3.91,0l-12.04,12.04c-.49.49-1.28.49-1.77,0-.49-.49-.49-1.28,0-1.77l12.04-12.04c.99-1,2.32-1.54,3.72-1.54s2.73.55,3.72,1.54c1,.99,1.54,2.32,1.54,3.72s-.55,2.73-1.54,3.72l-12.67,12.67c-1.33,1.33-3.11,2.07-4.99,2.07s-3.66-.73-4.99-2.07l-.3-.3c-1.42-1.42-2.2-3.31-2.2-5.32s.78-3.9,2.2-5.32L16.04,2.88c1.86-1.86,4.33-2.88,6.96-2.88s5.1,1.02,6.96,2.88c1.83,1.83,2.84,4.26,2.84,6.85s-1.01,5.02-2.84,6.85l-13.57,13.57c-.24.24-.56.37-.88.37Z"
                      />
                    </g>
                  </svg>
                  {{
                    finalFileList.length == 0 
                      ? $t('components.email.response.add_attachment') 
                      : $t('components.email.response.edit_attachments')
                  }}
                </div>
              </div>
              <div class="right-button-wrapp m-btn-wrapp">
                <div class="m-cancel-btn m-single-btn" @click="close()">
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M30.81,31.46c-.32,0-.64-.12-.88-.37L10.68,11.85c-.49-.49-.49-1.28,0-1.77.49-.49,1.28-.49,1.77,0l19.25,19.25c.49.49.49,1.28,0,1.77-.24.24-.56.37-.88.37Z"
                          />
                          <path
                            class="cls-2"
                            d="M11.56,31.46c-.32,0-.64-.12-.88-.37-.49-.49-.49-1.28,0-1.77L29.92,10.08c.49-.49,1.28-.49,1.77,0,.49.49.49,1.28,0,1.77L12.44,31.1c-.24.24-.56.37-.88.37Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  {{ $t('components.email.response.cancel') }}
                </div>
                <div class="m-save-btn m-single-btn" @click="saveEmailDraft()">
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M31.52,35.2H11.49c-2.53,0-4.6-2.06-4.6-4.6V10.58c0-2.53,2.06-4.6,4.6-4.6h16.7c.71,0,1.33.29,1.7.81.46.63,1.16,1.51,1.97,2.53,1.07,1.34,2.39,3.01,3.7,4.77.37.5.56,1.02.56,1.55v14.97c0,2.53-2.06,4.6-4.6,4.6ZM11.49,8.48c-1.16,0-2.1.94-2.1,2.1v20.03c0,1.16.94,2.1,2.1,2.1h20.02c1.16,0,2.1-.94,2.1-2.1v-14.95s-.02-.03-.06-.09c-1.28-1.72-2.59-3.37-3.64-4.7-.74-.93-1.39-1.75-1.87-2.39H11.49Z"
                          />
                          <path
                            class="cls-2"
                            d="M25.4,13.23h-7.98c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h7.98c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
                          />
                          <path
                            class="cls-2"
                            d="M28.33,30.65h-13.44c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h13.44c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  {{ $t('components.email.response.save_draft') }}
                </div>
                <div class="m-send-btn m-single-btn" @click="firstStepSend()">
                  <svg
                    id="Layer_2"
                    data-name="Layer 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 42 42"
                  >
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <g>
                          <path
                            class="cls-2"
                            d="M17.62,38.37c-.14,0-.28-.02-.43-.06-.65-.17-1.12-.72-1.2-1.39l-1.78-15.64L1.18,13.97c-.61-.34-.93-1.03-.8-1.71.13-.68.67-1.21,1.36-1.32h0l37.6-5.62c.65-.1,1.3.21,1.64.77.34.57.31,1.27-.08,1.81l-21.97,29.81c-.31.42-.8.66-1.31.66ZM4.54,13.02l11.26,6.32c.46.25.76.72.82,1.24l1.58,13.93,19.49-26.45L4.54,13.02ZM14.59,21.5h0,0ZM2.11,13.39h0s0,0,0,0h0Z"
                          />
                          <path
                            class="cls-2"
                            d="M15.4,21.96c-.43,0-.85-.23-1.08-.63-.34-.59-.13-1.35.47-1.68l23.18-13.09c.59-.34,1.35-.13,1.68.47.34.59.13,1.35-.47,1.68l-23.18,13.09c-.19.11-.4.16-.61.16Z"
                          />
                        </g>
                        <rect class="cls-1" x="0" width="42" height="42" />
                      </g>
                    </g>
                  </svg>
                  {{ $t('components.email.response.send') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </v-dialog>

    <action-confirmation-dialog
      :message="$t('components.email.response.confirm_send')"
      ref="sendMailConfirm"
      @confirm="sendEmail"
    />
    <action-invalid-dialog :message="err_msg" ref="errorDialog" />
    <email-local-upload-files
      ref="localFileUpload"
      @fileListLocalUpdate="fileListUpdate"
    />
  </div>
</template>

<script>
import email_handler from "../../services/email_handler";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@/plugins/ckeditor_build";

import DataLoader from "../generalComponents/DataLoader.vue";
import EmailAttachmentsEmailCompose from "./components/mail-client-firmwide/EmailAttachmentsEmailCompose.vue";
import EmailAutocompleteMulti from "./inputs/EmailAutocompleteMulti.vue";
import {
  initDraftByType,
  saveEditMessageDraft,
} from "../../helpers/email/messaging";
import ActionConfirmationDialog from "../generalComponents/ActionConfirmationDialog.vue";
import ActionInvalidDialog from "../generalComponents/ActionInvalidDialog.vue";
import EmailLocalUploadFiles from "./file-management/EmailLocalUploadFiles.vue";
import { showGlobalLoader, hideGlobalLoader } from "../../helpers/loader/global";
import toastService from "../../services/toast.service";

export default {
  components: {
    DataLoader,
    ckeditor: CKEditor.component,
    EmailAttachmentsEmailCompose,
    EmailAutocompleteMulti,
    ActionConfirmationDialog,
    ActionInvalidDialog,
    EmailLocalUploadFiles,
  },
  name: "FinalEmailResponse",
  data() {
    return {
      editor: ClassicEditor,
      editorData: "<p></p>",
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "fontSize", // 👈 Add this
            "link",
            "|",
            "undo",
            "redo",
            "|",
            "bulletedList",
            "numberedList",
            "texttransform",
            "",
          ],
        },
        link: {
          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
          addTargetToExternalLinks: true,
        },
      },
      loaded_ck: false,
      is_saving: false,
      cc_visible: false,
      bcc_visible: false,

      availableEmails: [],
      dialog: false,
      exit_delete_status: true,
      formData: {
        id: null,
        recipients: [],
        cc: [],
        bcc: [],
        subject: "",
        body: "",
      },
      emptyFormData: {
        id: null,
        recipients: [],
        cc: [],
        bcc: [],
        subject: "",
        body: "",
      },
      response_email_graph_created: null,
      is_created_from_reply: false, //Flag when user won't use the created RE: message
      isEditMode: false,
      refresher: 1,

      fileList: [],
      fwFileList: [],
      attached_attachments: [],
      previously_attached_reference: [],

      send_confirm_message: this.$t('components.email.response.confirm_send'),
      err_msg: this.$t('components.email.response.error'),

      // Timer reference for cleanup
      ckEditorTimer: null,
    };
  },
  computed: {
    finalFileList() {
      return this.fileList
        .concat(this.fwFileList)
        .concat(this.attached_attachments);
    },
  },
  methods: {
    deleteAttachmentFromArr(single_file_key) {
      const calibrate_val = single_file_key + 1;
      const local_len = this.fileList.length;
      const fw_len = this.fwFileList.length;

      if (calibrate_val <= local_len) {
        this.fileList.splice(single_file_key, 1);
      } else if (calibrate_val <= local_len + fw_len) {
        const fw_remove_idx = single_file_key - local_len;
        this.fwFileList.splice(fw_remove_idx, 1);
      } else {
        const attach_remove_idx = single_file_key - local_len - fw_len;
        this.attached_attachments.splice(attach_remove_idx, 1);
      }
    },
    fileListUpdate(file_upload_obj) {
      this.fileList = file_upload_obj.local_files;
      this.fwFileList = file_upload_obj.fw_files;
      this.attached_attachments = file_upload_obj.attached_files;
    },
    openLocalFileUpload() {
      this.$refs.localFileUpload.openDialog({
        local: [...this.fileList],
        fw: [...this.fwFileList],
        attached: [...this.attached_attachments],
      });
    },
    firstStepSend() {
      this.$refs.sendMailConfirm.openDialog();
    },

    async sendEmail() {
      const draft_id_response = await this.saveEmailDraft(true);
      try {
        if (draft_id_response) {
          await email_handler.sendDraftEmail(draft_id_response);
          this.dialog = false;
          toastService.success(this.$t('components.email.response.send_success'));
          this.$emit("successfull");
        }
      } catch {
        this.err_msg = this.$t('components.email.response.send_error');
        this.$refs.errorDialog.openDialog();
      }
    },
    resetData() {
      this.attached_attachments = [];
      this.formData = { ...this.emptyFormData };
      this.previously_attached_reference = [];
      this.fileList = [];
      this.fwFileList = [];
    },
    async open(email = null, type_of_email = 0) {
      this.resetData();

      // For forward (type 3), pass existing attachments to avoid re-downloading
      var existingAttachments = (type_of_email === 3 && email && email.attachments)
        ? email.attachments
        : null;

      this.formData = await initDraftByType(
        type_of_email,
        email && email.email ? email.email : null,
        existingAttachments
      );

      if (this.formData["attachments"]) {
        this.previously_attached_reference = [...this.formData["attachments"]];
        this.attached_attachments = [...this.formData["attachments"]];
      }
      if (type_of_email == -1) {
        //Check if it is continue edit so it can hold previous attachments
        var tmp_attach_arr = email && email.attachments ? [...email.attachments] : [];
        this.previously_attached_reference = [...tmp_attach_arr];
        this.attached_attachments = [...tmp_attach_arr];
      }
      this.exit_delete_status = type_of_email > 0;
      this.loaded_ck = false;
      this.dialog = true;
      // Clear any existing timer before setting a new one
      if (this.ckEditorTimer) {
        clearTimeout(this.ckEditorTimer);
      }
      this.ckEditorTimer = setTimeout(() => {
        this.loaded_ck = true;
      }, 100);
    },
    async close() {
      if (this.exit_delete_status) {
        await email_handler.deleteMessage(this.formData.id);
      }
      this.dialog = false;
    },
    getAttachmentObjectFinalised() {
      const attachedIds = this.attached_attachments.map(p => p.id);
      const attachmentsToDelete = this.previously_attached_reference.filter(
        p => !attachedIds.includes(p.id)
      );
      return {
        local: this.fileList,
        fw: this.fwFileList,
        delete: attachmentsToDelete,
      };
    },
    async saveEmailDraft(need_to_return = false) {
      showGlobalLoader(this.$t('components.email.response.saving'));
      const tmp_attachment_obj = this.getAttachmentObjectFinalised();
      try {
        const draft_id_response = await saveEditMessageDraft(
          this.formData,
          tmp_attachment_obj
        );
        this.formData.id = draft_id_response;
        if (need_to_return) {
          hideGlobalLoader();
          return draft_id_response;
        }
        hideGlobalLoader();
        this.$emit("successfull");
        this.resetFormData();
        this.dialog = false;
      } catch (error) {
        hideGlobalLoader();
        this.err_msg = this.$t('components.email.response.draft_save_error');
        this.$refs.errorDialog.openDialog();
        if (need_to_return) {
          return false;
        }
      }
    },

    resetFormData() {
      this.formData = {
        recipients: [],
        cc: [],
        bcc: [],
        subject: "",
        body: "",
      };
    },
  },
  beforeDestroy() {
    // Cleanup timer to prevent memory leaks
    if (this.ckEditorTimer) {
      clearTimeout(this.ckEditorTimer);
      this.ckEditorTimer = null;
    }
    // Reset CKEditor state
    this.loaded_ck = false;
  },
};
</script>
<style>
.v-dialog {
  box-shadow: none;
  border-radius: 20px;
}

/* Subject field styling */
.email-subject-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.subject-label {
  display: flex;
  align-items: center;
  padding: 0 4px;
}

.subject-label .label-text {
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #606076;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.email-subject-input.v-input {
  margin: 0;
  padding: 0;
}

.email-subject-input .v-input__control {
  min-height: 44px !important;
}

.email-subject-input .v-input__slot {
  background: #f8f9fc !important;
  border: 1.5px solid #e3e5ee !important;
  border-radius: 12px !important;
  padding: 6px 16px !important;
  min-height: 44px !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
}

.email-subject-input .v-input__slot:hover {
  border-color: #c7cae8 !important;
  background: #ffffff !important;
}

.email-subject-input.v-input--is-focused .v-input__slot {
  border-color: #372EAA !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 3px rgba(55, 46, 170, 0.1) !important;
}

.email-subject-input .v-text-field__slot input {
  font-family: "Barlow", sans-serif !important;
  font-size: 14px !important;
  color: #2b2b41 !important;
  padding: 8px 0 !important;
}

.email-subject-input .v-text-field__slot input::placeholder {
  color: #9ca3af !important;
  font-weight: 400 !important;
}

/* Remove default Vuetify underlines */
.email-subject-input .v-input__slot::before,
.email-subject-input .v-input__slot::after {
  display: none !important;
}

/* Body/Email label styling */
.email-body-wrapper {
  margin-bottom: 8px;
}

.body-label {
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #606076;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 4px;
  margin-bottom: 8px;
}

/* Attachment section styling */
.attachment-line {
  margin-top: 20px;
  padding: 16px;
  background: #fafbfc;
  border-radius: 12px;
  border: 1px solid #e3e5ee;
}
</style>
